import {SxType} from "@baseTypes/sx/sxTypes";
import {
    WIDTH_ROOT_SIDEBAR_SINGLE_VOYAGE,
    WIDTH_ROOT_SIDEBAR_SINGLE_VOYAGE_MINI_MODE
} from "@containers/singleVoyage/views/constants/size";
import {
    SV_DARK,
    SV_EASE,
    SV_LIGHT,
    SV_RADIUS_LG,
    SV_TRANSITION,
    svEnter
} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        borderRadius: SV_RADIUS_LG,
        border: '1px solid',
        overflow: 'hidden',
        paddingRight: '5px',
        paddingBottom: '10px',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        width: WIDTH_ROOT_SIDEBAR_SINGLE_VOYAGE,
        backgroundImage: 'none',
        transition: `${SV_TRANSITION}, width .32s ${SV_EASE}, padding .32s ${SV_EASE}`,
        ...svEnter(0),
        '&.miniMode': {
            width: WIDTH_ROOT_SIDEBAR_SINGLE_VOYAGE_MINI_MODE,
            paddingRight: '0',
        },
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.surface,
            borderColor: SV_LIGHT.line,
            boxShadow: SV_LIGHT.shadowSm,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.surface,
            borderColor: SV_DARK.line,
            boxShadow: SV_DARK.shadowSm,
        },
    },
    inner: {
        padding: '10px 5px 10px 15px',
        height: '100%',
        maxHeight: 'calc(100% - 40px)',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
    header: {
        padding: '10px 15px 5px',
        '&.miniMode': {
            display: 'flex',
            justifyContent: 'center'
        }
    },
    toggleIcon: {
        transition: `transform .32s ${SV_EASE}`,
        '.miniMode &': {
            transform: 'rotate(180deg)',
        },
        '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
        },
    }
}
